import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { ReportData, ReportQuestionData } from './report.constants';
import { TikZType, options } from 'src/app/constants/constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var update: any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnDestroy {
  role = localStorage['roleId'];
  student_id = '';
  test_id = '';
  test_date = '';
  test_details: any = null;
  studentTestId = '';
  testDetailsLoading = true;
  testDetailsLoaded = false;
  analysisLoaded = false;
  scoringSections: any[] = [];
  paramSubscription: Subscription;
  isDigital: boolean = false;
  displayQuestion: boolean = false;
  displayQuestionData: ReportQuestionData | null = null;
  showLoader: boolean = false;
  optionsText: string[] = options;
  private readonly notifier: NotifierService;
  isDPSAT: boolean = false;
  isDPSAT9: boolean = false;
  displayAnswer: boolean = false;
  displayQuestionNumber: number | null = null;
  sectionScores: any[] = [];
  totalScore = 0;
  totalMax = 0;
  questionVideos: any[] = [];
  selectedVideoUrl: any = null;
  selectedVideoIndex: number | null = null;
  constructor(
    public commonService: CommonService,
    public route: ActivatedRoute,
    public httpClient: HttpClient,
    notifierService: NotifierService,
    private globalApiService: GlobalApiService,
    private sanitizer: DomSanitizer
  ) {
    this.notifier = notifierService;
    this.paramSubscription = this.route.params.subscribe((params: Params) => {
      this.studentTestId = params['studentTestId'];
    });
  }

  ngOnInit() {
    this.httpClient
      .get(`/api/get_each_test_score?student_test_id=${this.studentTestId}`, {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      })
      .subscribe(
        (response: any) => {
          console.log(response);
          console.log(JSON.parse(response.data));
          this.testDetailsLoading = false;
          this.testDetailsLoaded = true;
          this.test_details = JSON.parse(response.data);
          this.isDPSAT =
            this.test_details['overview'][0]['test_code'].includes('DPSAT-');
          this.isDPSAT9 =
            this.test_details['overview'][0]['test_code'].includes('DPSAT9-');
          this.isDigital =
            this.test_details['overview'][0]['test_type_name'].includes(
              'Digital'
            );
          this.buildSectionScores();
          for (
            let i = 0;
            i < this.test_details['detailed_report']['length'];
            i++
          ) {
            for (
              let j = 0;
              j < this.test_details['detailed_report'][i]['sections']['length'];
              j++
            ) {
              const range: any = [];
              if (!this.isDigital) {
                for (
                  let k = 0;
                  k <
                  this.test_details['detailed_report'][i]['sections'][j][
                    'detail_report'
                  ]['length'] /
                    25;
                  k++
                ) {
                  range.push({
                    elements: [
                      ...this.test_details['detailed_report'][i]['sections'][j][
                        'detail_report'
                      ].slice(k * 25, k * 25 + 25)
                    ]
                  });
                }
              } else {
                const uniqueModules: string[] = [];
                /* Questions seperated by modules */
                for (let detailedReport of this.test_details['detailed_report'][
                  i
                ]['sections'][j]['detail_report']) {
                  if (!uniqueModules.includes(detailedReport.module_id)) {
                    uniqueModules.push(detailedReport.module_id);
                    range.push({
                      moduleId: detailedReport.module_id,
                      moduleName: detailedReport.module_name,
                      moduleOrder: detailedReport.module_order,
                      detailedReport: [detailedReport],
                      range: []
                    });
                  } else {
                    const moduleIndex = uniqueModules.indexOf(
                      detailedReport.module_id
                    );
                    range[moduleIndex].detailedReport.push(detailedReport);
                  }
                }
                /* Modules sorted in order */
                range.sort((first: any, second: any) =>
                  first.moduleOrder < second.moduleOrder ? -1 : 1
                );
                /* Questions sorted in order */
                for (let rangeElement of range) {
                  rangeElement.detailedReport.sort((first: any, second: any) =>
                    first.question_order < second.question_order ? -1 : 1
                  );
                }
                /* Questions sorted in range */
                for (let rangeElement of range) {
                  const questionRange = [];
                  for (
                    let k = 0;
                    k < rangeElement.detailedReport['length'] / 25;
                    k++
                  ) {
                    questionRange.push({
                      elements: [
                        ...rangeElement.detailedReport.slice(
                          k * 25,
                          k * 25 + 25
                        )
                      ]
                    });
                  }
                  rangeElement['range'] = questionRange;
                }
              }
              this.test_details['detailed_report'][i]['sections'][j]['range'] =
                range;
            }
          }

          console.log(this.test_details);
        },
        (error) => {
          this.notifier.notify('error', 'Unable to fetch report data');
          console.log(error);
          this.testDetailsLoading = false;
        }
      );
    this.httpClient
      .get(`/api/analysis?student_test_id=${this.studentTestId}`, {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      })
      .subscribe(
        (response: any) => {
          console.log(response);
          console.log(JSON.parse(response['data']));
          //           console.log('test_details =', this.test_details);
          // console.log('section_score =', this.test_details?.overview?.[0]?.section_score);
          // console.log(' test_type_name =', this.test_details?.overview?.[0]?.test_type_name);

          const data: any[] = JSON.parse(response['data']);
          const uniqueScoringSectionIds: any[] = []; //[1]
          const uniqueTopicIds: any[] = []; //[[1,2]]
          const uniqueSubTopicIds: any[] = []; //[[[1,2], [1]]]
          const scoringSections = [];
          for (let i = 0; i < data['length']; i++) {
            if (
              uniqueScoringSectionIds.indexOf(data[i]['scoring_section_id']) < 0
            ) {
              uniqueScoringSectionIds.push(data[i]['scoring_section_id']);
              uniqueTopicIds.push([]);
              uniqueTopicIds[
                uniqueScoringSectionIds.indexOf(data[i]['scoring_section_id'])
              ].push(data[i]['topic_id']);
              uniqueSubTopicIds.push([[]]);
              // uniqueSubTopicIds[uniqueTopicIds[uniqueScoringSectionIds.indexOf(data[i]['scoring_section_id'])]].push(data[i]['subtopic_id']);
              uniqueSubTopicIds[
                uniqueScoringSectionIds.indexOf(data[i]['scoring_section_id'])
              ][
                uniqueTopicIds[
                  uniqueScoringSectionIds.indexOf(data[i]['scoring_section_id'])
                ].indexOf(data[i]['topic_id'])
              ].push(data[i]['subtopic_id']);
              scoringSections.push({
                scoringSectionName: data[i]['scoring_section_name'],
                scoringSectionId: data[i]['scoring_section_id'],
                sectionId: data[i]['test_section_id'],
                tst_id: data[i]['tst_id'],
                topics: [
                  {
                    topicId: data[i]['topic_id'],
                    topicName: data[i]['topic_name'],
                    totalQuestions: data[i]['total_q'],
                    totalCorrect:
                      data[i]['c_type'] === 'correct' ? data[i]['total_q'] : 0,
                    subTopics: [
                      {
                        subTopicId: data[i]['subtopic_id'],
                        subTopicName: data[i]['subtopic_name'],
                        total: data[i]['total_q'],
                        tags: data[i]['tags']
                          ? JSON.parse(data[i]['tags'])
                          : [],
                        missed:
                          data[i]['c_type'] === 'missed'
                            ? data[i]['total_q']
                            : 0,
                        correct:
                          data[i]['c_type'] === 'correct'
                            ? data[i]['total_q']
                            : 0,
                        wrong:
                          data[i]['c_type'] === 'wrong'
                            ? data[i]['total_q']
                            : 0,
                        missedQuestions:
                          data[i]['c_type'] === 'missed' ? data[i]['ids'] : '',
                        wrongQuestions:
                          data[i]['c_type'] === 'wrong' ? data[i]['ids'] : ''
                      }
                    ]
                  }
                ]
              });
            } else {
              const scoringSectionIndex = uniqueScoringSectionIds.indexOf(
                data[i]['scoring_section_id']
              );
              if (
                uniqueTopicIds[scoringSectionIndex].indexOf(
                  data[i]['topic_id']
                ) < 0
              ) {
                uniqueTopicIds[scoringSectionIndex].push(data[i]['topic_id']);
                uniqueSubTopicIds[scoringSectionIndex].push([]);
                uniqueSubTopicIds[scoringSectionIndex][
                  uniqueTopicIds[scoringSectionIndex].indexOf(
                    data[i]['topic_id']
                  )
                ].push(data[i]['subtopic_id']);
                scoringSections[scoringSectionIndex]['topics'].push({
                  topicId: data[i]['topic_id'],
                  topicName: data[i]['topic_name'],
                  totalQuestions: data[i]['total_q'],
                  totalCorrect:
                    data[i]['c_type'] === 'correct' ? data[i]['total_q'] : 0,
                  subTopics: [
                    {
                      subTopicId: data[i]['subtopic_id'],
                      subTopicName: data[i]['subtopic_name'],
                      total: data[i]['total_q'],
                      tags: data[i]['tags'] ? JSON.parse(data[i]['tags']) : [],
                      missed:
                        data[i]['c_type'] === 'missed' ? data[i]['total_q'] : 0,
                      correct:
                        data[i]['c_type'] === 'correct'
                          ? data[i]['total_q']
                          : 0,
                      wrong:
                        data[i]['c_type'] === 'wrong' ? data[i]['total_q'] : 0,
                      missedQuestions:
                        data[i]['c_type'] === 'missed' ? data[i]['ids'] : '',
                      wrongQuestions:
                        data[i]['c_type'] === 'wrong' ? data[i]['ids'] : ''
                    }
                  ]
                });
              } else {
                const topicIndex = uniqueTopicIds[scoringSectionIndex].indexOf(
                  data[i]['topic_id']
                );
                const topic = {
                  ...scoringSections[scoringSectionIndex]['topics'][topicIndex]
                };
                scoringSections[scoringSectionIndex]['topics'][topicIndex][
                  'totalQuestions'
                ] = topic['totalQuestions'] + data[i]['total_q'];
                scoringSections[scoringSectionIndex]['topics'][topicIndex][
                  'totalCorrect'
                ] =
                  data[i]['c_type'] === 'correct'
                    ? topic['totalCorrect'] + data[i]['total_q']
                    : topic['totalCorrect'];
                if (
                  uniqueSubTopicIds[scoringSectionIndex][topicIndex].indexOf(
                    data[i]['subtopic_id']
                  ) < 0
                ) {
                  uniqueSubTopicIds[scoringSectionIndex][topicIndex].push(
                    data[i]['subtopic_id']
                  );
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ].push({
                    subTopicId: data[i]['subtopic_id'],
                    subTopicName: data[i]['subtopic_name'],
                    total: data[i]['total_q'],
                    tags: data[i]['tags'] ? JSON.parse(data[i]['tags']) : [],
                    missed:
                      data[i]['c_type'] === 'missed' ? data[i]['total_q'] : 0,
                    correct:
                      data[i]['c_type'] === 'correct' ? data[i]['total_q'] : 0,
                    wrong:
                      data[i]['c_type'] === 'wrong' ? data[i]['total_q'] : 0,
                    missedQuestions:
                      data[i]['c_type'] === 'missed' ? data[i]['ids'] : '',
                    wrongQuestions:
                      data[i]['c_type'] === 'wrong' ? data[i]['ids'] : ''
                  });
                } else {
                  const subTopicIndex = uniqueSubTopicIds[scoringSectionIndex][
                    topicIndex
                  ].indexOf(data[i]['subtopic_id']);
                  const subtopic = {
                    ...scoringSections[scoringSectionIndex]['topics'][
                      topicIndex
                    ]['subTopics'][subTopicIndex]
                  };
                  const tags = subtopic['tags'];
                  if (data[i]['tags']) {
                    const dataTags = JSON.parse(data[i]['tags']);
                    dataTags.forEach((tag: string) => {
                      if (!tags.includes(tag)) {
                        tags.push(tag);
                      }
                    });
                  }
                  // tags = tags.concat(
                  //   data[i]['tags'] ? JSON.parse(data[i]['tags']) : []
                  // );

                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['tags'] = tags;
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['missed'] =
                    data[i]['c_type'] === 'missed'
                      ? subtopic['missed'] + data[i]['total_q']
                      : subtopic['missed'];
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['correct'] =
                    data[i]['c_type'] === 'correct'
                      ? subtopic['correct'] + data[i]['total_q']
                      : subtopic['correct'];
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['wrong'] =
                    data[i]['c_type'] === 'wrong'
                      ? subtopic['wrong'] + data[i]['total_q']
                      : subtopic['wrong'];
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['missedQuestions'] =
                    data[i]['c_type'] === 'missed'
                      ? data[i]['ids']
                      : subtopic['missedQuestions'];
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['wrongQuestions'] =
                    data[i]['c_type'] === 'wrong'
                      ? data[i]['ids']
                      : subtopic['wrongQuestions'];
                  scoringSections[scoringSectionIndex]['topics'][topicIndex][
                    'subTopics'
                  ][subTopicIndex]['total'] =
                    data[i]['total_q'] + subtopic['total'];
                }
              }
            }
          }
          console.log(scoringSections);
          this.scoringSections = scoringSections;
          this.analysisLoaded = true;
        },
        (error) => {
          console.log(error);
          this.notifier.notify('error', 'Unable to load Analysis report');
        }
      );
  }
  buildSectionScores() {
    const scores = this.test_details?.overview?.[0]?.section_score || {};

    this.sectionScores = Object.keys(scores).map((key) => {
      return {
        name: key,
        score: scores[key]?.score ?? 0,
        max: scores[key]?.max ?? 0
      };
    });

    this.totalScore = this.sectionScores.reduce((sum, s) => sum + s.score, 0);
    this.totalMax = this.sectionScores.reduce((sum, s) => sum + s.max, 0);
  }

  scrollTo(id: any) {
    // const element = document.getElementById(id);
    // element.scrollIntoView();
    let element = document.getElementById(id);
    if (element) {
      let headerOffset = 100;
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openQuestion(element: any, questionNumber: number) {
    /*  This function is to be triggered only when the test is Digital */
    this.displayQuestionData = null;
    this.displayAnswer = false;
    this.displayQuestionNumber = null;

    if (!this.showLoader) {
      this.showLoader = true;
      if (element.questionData) {
        this.showLoader = false;
        this.displayQuestionData = element.questionData;
        this.displayQuestion = true;
        this.displayQuestionNumber = questionNumber;
        setTimeout(() => {
          this.loadTikZ();
        }, 500);
      } else {
        this.getQuestion(element, questionNumber);
      }
    }
  }

  getQuestion(element: any, questionNumber: number) {
    console.log(element);
    this.globalApiService
      .getQuestionDataForStudent(element.question_id, this.studentTestId)
      .subscribe({
        next: (response: ReportQuestionData) => {
          console.log(response);
          this.showLoader = false;
          const listOfImages: string[] = [];
          element.questionData = response;
          response.question.questionData.forEach((question: ReportData) => {
            if (question['type'] === 'Images') {
              question['images'] = JSON.parse(question['data']) || [];
              if (question['images']) listOfImages.push(...question['images']);
              question['data'] = '';
            }
          });
          if (response.question.questionType === 1) {
            const choices = response.choices || [];
            for (let choice of choices) {
              const optionValue: ReportData[] = choice.optionValue || [];
              for (let option of optionValue) {
                if (option['type'] === 'Images') {
                  option['images'] = JSON.parse(option['data']) || [];
                  if (option['images']) listOfImages.push(...option['images']);
                  option['data'] = '';
                }
              }
              if (choice.isAnswer) {
                const explanations: ReportData[] = choice.explanation || [];
                explanations.forEach((explanation) => {
                  if (explanation['type'] === 'Images') {
                    explanation['images'] =
                      JSON.parse(explanation['data']) || [];
                    if (explanation['images'])
                      listOfImages.push(...explanation['images']);
                    explanation['data'] = '';
                  }
                });
                // break;
              }
            }
          } else if (response.question.questionType === 2) {
            response.answers?.explanation.forEach((explanation: ReportData) => {
              if (explanation['type'] === 'Images') {
                explanation['images'] = JSON.parse(explanation['data']) || [];
                if (explanation['images'])
                  listOfImages.push(...explanation['images']);
                explanation['data'] = '';
              }
              return explanation;
            });
          }
          if (listOfImages.length > 0) this.getImages(listOfImages, element);
          element.questionData = response;
          this.displayQuestionData = response;
          if (response?.videos?.length) {
            response.videos.sort(
              (a: any, b: any) => a.displayOrder - b.displayOrder
            );
            element.questionData.videos = response.videos;
          }
          this.displayQuestionData.difficultyLevel = this.getDifficultyLevel(
            element.difficult_level_code
          );
          this.displayQuestionNumber = questionNumber;
          this.displayQuestion = true;
          setTimeout(() => {
            this.loadTikZ();
          }, 500);
        },
        error: (error: any) => {
          console.log(error);
          this.showLoader = false;
          this.notifier.notify('error', 'Unable to load question details');
        }
      });
  }
  playVideo(video: any, index: number) {
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      video.iframeUrl
    );
    this.selectedVideoIndex = index;
  }
  closeVideo() {
    this.selectedVideoUrl = null;
    this.selectedVideoIndex = null;
  }
  getImages(listOfImages: string[], element: any) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          element.questionData.images = data;
          if (this.displayQuestionData) this.displayQuestionData.images = data;
        }
        console.log(element.questionData.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getDifficultyLevel(difficultyLevel: string): string {
    let level = '';
    switch (difficultyLevel) {
      case 'H':
        level = 'Hard';
        break;
      case 'M':
        level = 'Medium';
        break;
      case 'E':
        level = 'Easy';
        break;
      default:
        break;
    }
    return level;
  }

  loadTikZ() {
    console.log(this.displayQuestionData);
    const totaltikZ: TikZType[] = [];
    this.displayQuestionData?.question.questionData.forEach(
      (question, questionIndex) => {
        if (question.type === 'TikZ') {
          totaltikZ.push({
            id: 'report-tikz-' + questionIndex,
            data: question.data
          });
        }
      }
    );
    console.log(totaltikZ);
    let choices = this.displayQuestionData?.choices || [];
    for (let [choiceIndex, choice] of choices.entries()) {
      if (choice.isAnswer) {
        choice.optionValue.forEach((option, optionIndex) => {
          if (option.type === 'TikZ') {
            totaltikZ.push({
              id: 'report-tikz-' + choiceIndex + '-' + optionIndex,
              data: option.data
            });
          }
          console.log(option);
        });
        // ** LOad tikz for Explanations
        choice.explanation?.forEach(
          (explanation: any, explanationIndex: any) => {
            if (explanation.type === 'TikZ') {
              totaltikZ.push({
                id:
                  'report-tikz-explanation-' +
                  choiceIndex +
                  '-' +
                  explanationIndex,
                data: explanation.data
              });
            }
          }
        );
      }
      choice.optionValue.forEach((option, optionIndex) => {
        if (option.type === 'TikZ') {
          totaltikZ.push({
            id: 'report-tikz-option-' + choiceIndex + '-' + optionIndex,
            data: option.data
          });
        }
        console.log(option);
      });
    }

    this.displayQuestionData?.answers?.explanation?.forEach(
      (explanation, explanationIndex) => {
        if (explanation.type === 'TikZ') {
          console.log(explanation);
          console.log('exp tikz -> ', explanation.data);
          totaltikZ.push({
            id: 'tikzOutput-freetextExplanation-' + explanationIndex,
            data: explanation.data
          });
        }
      }
    );
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 1000);
  }

  toggleDisplayAnswer() {
    this.displayAnswer = !this.displayAnswer;
    if (this.displayAnswer) {
      this.loadTikZ();
    }
  }

  ngOnDestroy() {
    this.paramSubscription.unsubscribe();
  }
}
